import type { FeatureConfig } from '../features-config'

export const hasFeatureAccess = (featureConfig: FeatureConfig, userEmail?: string | null): boolean => {
  if (!featureConfig.enabled) {
    return false
  }

  if (!featureConfig.allowedEmailSuffixes || featureConfig.allowedEmailSuffixes.length === 0) {
    return true
  }

  if (!userEmail) {
    return false
  }

  const escapedSuffixes = featureConfig.allowedEmailSuffixes.map(suffix => {
    const suffixWithAt = suffix.startsWith('@') ? suffix : `@${suffix}`
    return suffixWithAt.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  })

  const pattern = new RegExp(`(${escapedSuffixes.join('|')})$`, 'i')

  return pattern.test(userEmail)
}
